
  import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
  import { mapActions } from 'vuex'
  import { Query } from '@/entities/public/Resource/interfaces'
  import { formFilter } from '@/graphql/generated-types'

@Component({
  methods: {
    ...mapActions('resources/form', ['fetchData']),
  },
})
  export default class GPpu extends Vue {
  @Prop({ type: String, default: '' }) readonly value!: string
  @Prop({ type: String, default: 'Patente' }) readonly label!: string
  @Prop({ type: Boolean, default: false }) readonly required!: boolean
  @Prop({ type: Boolean, default: false }) readonly allowMotorBike!: boolean
  @Prop({ type: Array, default: () => [] }) readonly errorMessages!: Array<string>

  fetchData!: (payload: {
    query: Query
    filter?: formFilter
    offset?: number
    limit?: number
    force?: boolean
    distinct?: Array<string>
  }) => Promise<any>;

  innerValue: string = ''
  maxYears: number = 10
  allowMotorbike: boolean = false
  yearLimit: number = 0
  isConfigReady: boolean = false
  internalRules: any[] = []
  isDeleting: boolean = false

  @Watch('value', { immediate: true })
  onValueChange (newValue: string) {
    if (this.innerValue !== newValue) {
      this.innerValue = newValue || ''
    }
  }

  @Watch('innerValue')
  onInnerValueChange (newValue: string) {
    this.$emit('input', newValue)
    this.updateValidation()
  }

  @Watch('yearLimit')
  @Watch('allowMotorbike')
  @Watch('required')
  updateValidation () {
    const rules = []

    if (this.required) {
      rules.push(v => !!v || 'Campo requerido')
    }

    rules.push(v => {
      if (!v || v.length < 4) return true

      const oldFormatRegex = /^[B-DF-HJ-NP-TV-Z]{2}[0-9]{4}$/i // 2 letras + 4 dígitos
      const newFormatRegex = /^[B-DF-HJ-NP-TV-Z]{4}[0-9]{2}$/i // 4 letras + 2 dígitos
      const motorbikeRegex = /^[B-DF-HJ-NP-TV-Z]{3}[0-9]{2}$/i // 3 letras + 2 dígitos

      if (this.allowMotorbike) {
        return motorbikeRegex.test(v) || 'Formato inválido: debe tener 3 letras seguidas de 2 dígitos'
      } else if (this.yearLimit <= 2007) {
        // Para años 2007 o anteriores, permitir ambos formatos
        return (oldFormatRegex.test(v) || newFormatRegex.test(v)) ||
          'Formato inválido: debe tener 2 letras + 4 dígitos o 4 letras + 2 dígitos'
      } else {
        return newFormatRegex.test(v) || 'Formato inválido: debe tener 4 letras seguidas de 2 dígitos'
      }
    })

    this.internalRules = rules
  }

  get currentMask () {
    if (this.isDeleting) {
      return null
    }

    const baseTokens = {
      C: {
        pattern: /(?![aeiouAEIOU])[A-Za-z]/,
        transform: 'toUpperCase',
      },
    }

    if (this.allowMotorbike) {
      return {
        mask: 'CCC##',
        tokens: baseTokens,
      }
    }

    if (this.yearLimit <= 2007) {
      // Para vehículos de 2007 o anteriores, usar una máscara menos restrictiva
      return {
        mask: 'XXXXXX',
        tokens: {
          X: {
            pattern: /(?![aeiouAEIOU])[A-Za-z0-9]/,
            transform: 'toUpperCase',
          },
        },
      }
    }

    // Default to new format only
    return {
      mask: 'CCCC##',
      tokens: baseTokens,
    }
  }

  created () {
    this.innerValue = this.value || ''
  }

  async mounted () {
    const process = (await this.fetchData({
      query: { name: 'find', model: 'Process' },
      filter: { table_name: { _eq: 'auto' } },
      force: true,
    }))[0]
    const config = process?.config
    this.maxYears = config?.maxYear || this.maxYears
    this.allowMotorbike = this.allowMotorBike

    const currentYear = new Date().getFullYear()
    this.yearLimit = currentYear - this.maxYears

    this.isConfigReady = true
    this.updateValidation()
  }
  }
